import _ from 'lodash';
import { DATA_REDUX_STATE_KEY, dataCreators } from '../../actions/dataAction';
import { ModelAdNoti } from '../../models/ModelAdNoti';
import { ModelUserNoti } from '../../models/ModelUserNoti';
import { storeDispatch, storeGetState } from '../../stores';
import { DATE_TIME_FORMAT } from '../constants/data';
import { getUserAuth } from '../functions/auth';
import { displayDate } from '../functions/display';
import { handleAddFirebase, handleQueryFirebase, handleSetFirebase, handleUpdateFirebase } from './firebaseManageData';

let qSnapNotiUnsub = () => { };

export const firebaseUnsubscribeNoti = () => {
  console.log('firebaseUnsubscribeNoti')
  qSnapNotiUnsub();
}

export const firebaseUpdateReadNoti = () => {
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        const dataNoti = storeGetState().dataRedux.firebaseNoti;
        const notiList = dataNoti.dataList;
        const readNotiList = notiList.filter(e => e.isNew);
        if (readNotiList.length) {
          let cnt = 0;
          const updatedDate = new Date();
          readNotiList.forEach(async (e) => {
            await handleUpdateFirebase('notification', e.firebaseKey, {
              'isNew': false,
              'updatedDate': updatedDate.getTime(),
              'displayUpdatedDate': displayDate(updatedDate, '/', DATE_TIME_FORMAT)
            });
            cnt++;
            if (cnt === readNotiList.length) {
              resolve();
            }
          })
        }
      }
      catch (err) {
        reject(err);
        console.log('err', { err });
      }
    })();
  });
}

export const handleWatchAllNoti = async () => {
  await handleWatchNoti();
}

const setFirebaseNotiDataList = (qSnapNoti) => {
  const dataList = [];
  qSnapNoti.docs.forEach(qSnap => {
    let data = qSnap.data();
    data.firebaseKey = qSnap.id;
    data.firebasePath = qSnap.ref.parent.path;
    dataList.push(data);
  })
  const firebaseNoti = storeGetState().dataRedux.firebaseNoti;
  firebaseNoti.dataList = _.uniqBy(_.orderBy([...firebaseNoti.dataList, ...dataList], 'createdDate', 'desc'), 'createdDate');
  console.log('setFirebaseNotiDataList', _.cloneDeep(dataList), _.cloneDeep(firebaseNoti.dataList))
  storeDispatch(dataCreators.setDataRedux(DATA_REDUX_STATE_KEY.FIREBASE_NOTI, _.cloneDeep(firebaseNoti)));
  return dataList;
}

export const firebaseGetNotificationLoadMore = () => {
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        const userAuth = getUserAuth();
        const firebaseNoti = storeGetState().dataRedux.firebaseNoti;
        const lastData = firebaseNoti.dataList[firebaseNoti.dataList.length - 1];
        console.log('lastData', lastData)
        const where = ['dealerAccount', '==', userAuth.dealerAccount];
        const qSnapNoti = await handleQueryFirebase(`notification`, {
          where,
          orderBy: 'createdDate',
          maxLength: 10,
          lastRef: lastData?.firebasePath,
          lastDocRef: lastData?.firebaseKey
        });
        const dataList = setFirebaseNotiDataList(qSnapNoti);
        resolve(dataList);
      }
      catch (err) {
        reject(err);
        console.log('err', { err });
      }
    })();
  });
}

const handleWatchNoti = () => {
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        const userAuth = getUserAuth();
        if (userAuth) {
          qSnapNotiUnsub();
          const where = ['dealerAccount', '==', userAuth.dealerAccount];
          qSnapNotiUnsub = await handleQueryFirebase(`notification`, {
            where,
            orderBy: 'createdDate',
            maxLength: 10,
            callType: 'onSnapshot',
            callbackSuccess: async (qSnapNoti) => {
              setFirebaseNotiDataList(qSnapNoti);
              resolve();
            }
          });
        }
        else {
          resolve()
        }
      }
      catch (err) {
        reject(err);
        console.log('err', { err });
      }
    })();
  });
}

export const firebaseAddNoti = (params = {}) => {
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        await handleSetFirebase('notification', params.createdDate.toString(), params);
        resolve();
      }
      catch (err) {
        reject(err);
        console.log('err', { err }, params);
      }
    })();
  });
}

export const firebaseAddNotiCMS = (params = {}) => {
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        await handleSetFirebase('notification_cms', params.createdDate.toString(), params);
        resolve();
      }
      catch (err) {
        reject(err);
        console.log('err', { err }, params);
      }
    })();
  });
}